(function ()
{
    "use strict";

    angular
        .module('app.custom',
            [
                "angular-chartist",
                "chart.js",
                "datatables",
                "gridshore.c3js.chart",
                "nvd3",
                "timer",
                "ct.ui.router.extras",
                "oc.lazyLoad",
                "ui.sortable",
                "ng-sortable",
                "xeditable",
                "ui.select",
                "angular-bind-html-compile",
                "ui.mask",
                "jlareau.bowser",
                "foTooltip",
                "material.components.expansionPanels",
                "focus-if",
                "angular-uri",
                "angular.filter",
                "chrome-autofill-fix",
                "md-virtual-repeat-scrollbar",
                "md-virtual-repeat-scroll-fix",
                "bb.scrollWhen",
                
                // Módulos do STF Digital
                "app.login",
                "app.cadastro",
                "app.novo-processo",
                "app.gestao",
                "app.gestao.meus-paineis",
                "app.pesquisa-avancada",
                "app.documentos",
                "app.tarefas.minhas-tarefas",
                "app.tarefas.details",
                "app.configuracoes",
                "app.acoes",
                "app.informacoes",
                "app.legacy",
                "app.upgraded",
                "app.openState",
                "ui.tinymce",
                "ivh.treeview"
            ]);
})();